import { TablePaginationActions } from '@/components/table/TablePaginationActions';
import { Box, TablePagination } from '@mui/material';
import React from 'react';

const InfiniteTablePagination = ({
	count,
	page,
	setPage,
	rowsPerPage,
	setRowsPerPage,
	rowsPerPageOptions = [10],
	hasNextPage,
	hasPreviousPage,
}) => {
	const handleChangePage = async (event, newPage) => {
		console.log('[handleChangePage] NEW PAGE', newPage, 'OLD PAGE', page);
		setPage(newPage);
	};

	const handleRowsPerPageChange = (event) => {
		if (!setRowsPerPage) return;

		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	return (
		<Box width='100%' justifyItems='end'>
			<TablePagination
				count={count}
				// labelDisplayedRows={({ from, to, count, page }) => {
				// 	console.log({ from, to, count, page });
				// 	if (searchValue) {
				// 		return `${from}–${to} of ${!hasNextPage ? total : `more than ${to}`}`;
				// 	}
				// 	return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
				// }}
				rowsPerPageOptions={rowsPerPageOptions}
				rowsPerPage={rowsPerPage ?? 0}
				page={page}
				component={'div'}
				SelectProps={{
					inputProps: {
						'aria-label': 'Rows per page',
					},
					native: true,
				}}
				sx={{
					display: 'block',
					width: '100%',
				}}
				showFirstButton
				showLastButton={false}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleRowsPerPageChange}
				ActionsComponent={TablePaginationActions}
				slotProps={{
					actions: {
						nextButton: {
							disabled: !hasNextPage,
						},
						previousButton: {
							disabled: !hasPreviousPage,
						},
					},
				}}
			/>
		</Box>
	);
};

export default InfiniteTablePagination;
